import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mt-8 mb-4" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass(["mt-4", _ctx.config.classes?.questionClass]),
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 10, _hoisted_6),
            (_ctx.config.textPart3)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.config.textPart2)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_draggable, {
                modelValue: _ctx.list,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
                class: "flex flex-col",
                group: "options-list",
                "item-key": "id"
              }, {
                item: _withCtx(({element}) => [
                  _createVNode(_component_ActionButton, {
                    preicon: '=',
                    "button-class": "answer-button mb-4 whitespace-nowrap flex-1 text-left",
                    text: element.name,
                    class: _normalizeClass(_ctx.config.classes?.sortButtonClass)
                  }, null, 8, ["text", "class"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(_component_BackNextButtons, {
              class: "mt-8",
              "color-class": _ctx.config.classes?.nextButtonClass,
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.answer()))
            }, null, 8, ["color-class", "go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-4 min-h-75vh flex-col items-center flex",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: contain; background-position: center; background-repeat: no-repeat; ${_ctx.config.bgStyles}`)
          }, null, 4)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}